import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export type MatchValidatorOptions = Readonly<{
  source: string;
  target: string;
  errorKey?: string;
}>;

export const matchFieldsValidator = ({
  source,
  target,
  errorKey = 'fieldsMismatch',
}: MatchValidatorOptions): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const group = control as FormGroup;
    const sourceControl = group.get(source);
    const targetControl = group.get(target);

    if (!sourceControl || !targetControl) {
      return null;
    }

    const sourceValue = sourceControl.value ?? '';
    const targetValue = targetControl.value ?? '';
    const hasBothValues = sourceValue !== '' && targetValue !== '';
    const mismatch = hasBothValues && sourceValue !== targetValue;
    const currentErrors = targetControl.errors ?? {};

    if (mismatch) {
      targetControl.setErrors({
        ...currentErrors,
        [errorKey]: true,
      });

      return { [errorKey]: true };
    }

    if (currentErrors[errorKey]) {
      const { [errorKey]: _removed, ...remainingErrors } = currentErrors;
      targetControl.setErrors(
        Object.keys(remainingErrors).length > 0 ? remainingErrors : null,
      );
    }

    return null;
  };
};
